import http from '../utils/http'
import api from '../utils/api'

export async function bind(sharer_wechat_id) {
  return await http.post(api.distribution.bind(sharer_wechat_id), {})
}
